export default __webpack_public_path__ + "static/blister-nutri-color-c7403f1a96403725b136619883fb09c0.webp";